import * as api from '../../api/api-cambiar-gestion';
import { 
    GET_CONFIG_FORM13,
    GET_COMBO_TIPO_GESTION,
    GET_COMBO_CAMBIAR_AMBITO_GESTION,
    GET_COMBO_HITOS,
    POST_CAMBIAR_GESTION
} from '../types';

export const configuracionFormAction13 = (query) => ({
    type: GET_CONFIG_FORM13,
    payload: api.getConfiguracionForm13(query)
});
export const obtenerComboTipoGestion = (query) => ({
    type: GET_COMBO_TIPO_GESTION,
    payload: api.getComboTipoGestion(query)
});
export const obtenerComboCambiarAmbitoGestion = (query) => ({
    type: GET_COMBO_CAMBIAR_AMBITO_GESTION,
    payload: api.getComboAmbitoGestion(query)
});
export const obtenerComboHitos = (query) => ({
    type: GET_COMBO_HITOS,
    payload: api.getComboHitos(query)
});
export const PostCambiarGestion = (newGestion) => ({
    type:POST_CAMBIAR_GESTION,
    payload: api.cambiarTipoGestion(newGestion)
});
